import React, { Component } from "react";
import { Button } from "antd";
import queryString from "query-string";

import PhoneVerificationIcon from "icons/PhoneVerificationIcon";
import InputText from "components/InputText";
import { displayGenericError } from "common/notifications";
import { validatePassword } from "utils/utils";
import { resetPassword } from "api/api";
import "./ResetPasswordPage.scss";

export default class ResetPasswordPage extends Component {
  state = {
    password: "",
    confirmPassword: "",
    resetPasswordSuccess: false
  };

  resetPassword = () => {
    const { password, confirmPassword } = this.state;
    if (!validatePassword(password)) {
      displayGenericError({
        message:
          "Your password must be have at least 8 characters with 1 uppercase and 1 lowercase"
      });
      return;
    }

    if (password !== confirmPassword) {
      displayGenericError({
        message: "Your password is not match"
      });
      return;
    }

    const { token, id } = queryString.parse(this.props.location.search);
    resetPassword({ password, token, id })
      .then(response => {
        if (response.result === "success") {
          this.setState({
            resetPasswordSuccess: true
          });
        } else {
          displayGenericError({ message: response.result });
        }
      })
      .catch(e => displayGenericError(e));
  };

  render() {
    return (
      <div className="reset-password-wrapper">
        <div className="inner-content">
          <span className="svg-icon">
            <PhoneVerificationIcon />
          </span>
          {!this.state.resetPasswordSuccess && (
            <>
              <h2 className="fw-700">Reset Password</h2>
              <p className="describe">
                Your password must be have at least 8 characters with 1 uppercase and 1 lowercase to reset your password 
              </p>
              <InputText
                type="password"
                title="New Password"
                className="line-bottom-input"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
              />
              <InputText
                type="password"
                title="Confirm Password"
                className="line-bottom-input"
                value={this.state.confirmPassword}
                onChange={e => this.setState({ confirmPassword: e.target.value })}
              />

              <div className="buttons-section">
                <Button
                  type="primary"
                  className="btn-wide-md"
                  onClick={this.resetPassword}
                >
                  Save Password
                </Button>
              </div>
            </>
          )}
          {this.state.resetPasswordSuccess && (
            <>
              <h2 className="fw-700">
                Your password has been reset.
              </h2>
              <p className="describe ">
                Proceed to sign in with your new password.
              </p>
              <div className="buttons-section">
                <Button
                  type="primary"
                  className="btn-wide-md"
                  onClick={() => this.props.history.push("/login?hide-signup-modal=true")}
                >
                  Proceed to sign in
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
